/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Language_SelectInputs */

const en_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Language Select`)
};

const fr_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection de la langue cible`)
};

const de_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielsprache auswählen`)
};

const it_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la lingua di destinazione`)
};

const ru_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор целевого языка`)
};

const es_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar idioma de destino`)
};

const zh_cn2_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标语言选择`)
};

const ja_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲット言語の選択`)
};

const hi_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य भाषा चुनें`)
};

const pt_pt2_target_language_select = /** @type {(inputs: Target_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o idioma de destino`)
};

/**
* | output |
* | --- |
* | "Target Language Select" |
*
* @param {Target_Language_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_language_select = /** @type {((inputs?: Target_Language_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Language_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_language_select(inputs)
	if (locale === "de") return de_target_language_select(inputs)
	if (locale === "it") return it_target_language_select(inputs)
	if (locale === "ru") return ru_target_language_select(inputs)
	if (locale === "es") return es_target_language_select(inputs)
	if (locale === "zh-CN") return zh_cn2_target_language_select(inputs)
	if (locale === "ja") return ja_target_language_select(inputs)
	if (locale === "hi") return hi_target_language_select(inputs)
	if (locale === "pt-PT") return pt_pt2_target_language_select(inputs)
	return en_target_language_select(inputs)
});